import { useEffect } from "react";

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Lightweight SEO helper (no react-helmet dependency).
 * @param {{ title?: string, description?: string, canonicalPath?: string }} seo
 */
export default function usePageSeo(seo) {
  useEffect(() => {
    if (!seo) return undefined;
    const prevTitle = document.title;
    if (seo.title) document.title = seo.title;
    upsertMeta("name", "description", seo.description);
    if (seo.canonicalPath) {
      const origin = window.location.origin.replace(/\/$/, "");
      upsertLink("canonical", `${origin}${seo.canonicalPath}`);
    }
    return () => {
      document.title = prevTitle;
    };
  }, [seo?.title, seo?.description, seo?.canonicalPath]);
}
